compiler('#shop_settings_woocommerce_shop_setting_api_version', (element)=> {
    function hideCheckboxes(version_name) {
        if (version_name.startsWith('wp')) {
            $('#wp_settings').show()
        } else {
            $('#wp_settings').hide()
        }
    }

    element.addEventListener('change', function() {
        const selectedValue = this.value;
        hideCheckboxes(selectedValue);
    });

    const selectedValue = element.value;
    hideCheckboxes(selectedValue);
});
